/**
 * Заголовок и подпись верхней панели для вкладки.
 *
 * 🔴 Строка одна на все экраны и одной формы: название раздела жирным, серым —
 * подсказка или имя открытой записи (замечание владельца 24.09.2026: верно на
 * «Метриках» и «Протоколе», остальные экраны выглядели каждый по-своему).
 * До 24.09 у единого экрана «Распознавание» названия в строке не было — только
 * серый путь «Новая запись» (решение 07.09); это и стало разнобоем.
 *
 * recordTitle — имя открытой записи: на экране распознавания и на протоколе
 * оно встаёт на место подсказки, потому что подсказку уже говорит сам экран.
 * Без него на протоколе было не понять, какая из записей Истории открыта
 * (обращение ca6a5f12, 02.11.2026).
 */
export const RECOGNITION_TITLE = 'Распознавание';
export const RECOGNITION_HINT = 'Файл, ссылка на видео, встреча или запись с микрофона';

export function tabChrome(tab, { titles, hints, recognitionV2, recordTitle = null }) {
  if (recognitionV2 && tab === 'transcription') {
    return { title: RECOGNITION_TITLE, subtitle: recordTitle || RECOGNITION_HINT };
  }
  if (tab === 'protocol' && recordTitle) {
    return { title: titles[tab], subtitle: recordTitle };
  }
  return { title: titles[tab], subtitle: hints[tab] };
}
